import { useState } from 'react';
import useTableContext, {
  PageType
} from '../../../../admin-portal/BaseTabsRouting/Headers/HeaderGrid/useTableContext';

import type { Dispatch, FC, SetStateAction } from 'react';

export interface WithInnerLayoutProps {
  isInnerLayoutOpen: boolean;
  setIsInnerLayoutOpen: Dispatch<SetStateAction<boolean>>;
}

const WithInnerLayout = <CProps extends WithInnerLayoutProps>(
  Component: FC<CProps>
) => {
  function WithInnerLayoutWrapper(props: CProps) {
    'use memo';

    const {
      context: { setPageType }
    } = useTableContext();

    const [isInnerLayoutOpen, setIsInnerLayoutOpen] = useState(false);

    const handleSetIsInnerLayoutOpen = (isOpen: SetStateAction<boolean>) => {
      const nextValue =
        typeof isOpen === 'function' ? isOpen(isInnerLayoutOpen) : isOpen;
      setIsInnerLayoutOpen(nextValue);
      setPageType(nextValue ? PageType.DETAIL : PageType.LIST);
    };

    return (
      <Component
        {...props}
        isInnerLayoutOpen={isInnerLayoutOpen}
        setIsInnerLayoutOpen={handleSetIsInnerLayoutOpen}
      />
    );
  }
  return WithInnerLayoutWrapper;
};

export default WithInnerLayout;
